(() => {
  if (customElements.get('pb-work-gallery')) return;
  class WorkGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.items = [...this.querySelectorAll('[data-gallery-item]')];
      this.filters = [...this.querySelectorAll('[data-filter]')];
      this.dialog = this.querySelector('dialog');
      this.limit = Number(this.dataset.pageSize) || 12;
      this.category = 'all';
      this.shown = this.limit;
      this.matches = this.items;
      this.filters.forEach(button => {
        button.hidden = button.dataset.filter !== 'all' && !this.items.some(item => item.dataset.category === button.dataset.filter);
        button.addEventListener('click', () => {this.category=button.dataset.filter;this.shown=this.limit;this.update();},options);
      });
      this.querySelector('[data-gallery-tools]').hidden = !this.items.length;
      this.querySelector('[data-gallery-more]').addEventListener('click', () => {
        const firstNew = this.matches[this.shown];
        this.shown += this.limit; this.update();
        firstNew?.querySelector('[data-gallery-open]').focus({preventScroll:true});
      },options);
      this.items.forEach(item => item.querySelector('[data-gallery-open]').addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0 || typeof this.dialog.showModal !== 'function') return;
        event.preventDefault(); this.opener=event.currentTarget; this.current=this.matches.indexOf(item);
        this.showPhoto(); this.dialog.showModal(); document.documentElement.classList.add('pb-gallery-modal-open');
      },options));
      this.querySelector('[data-gallery-close]').addEventListener('click',()=>this.dialog.close(),options);
      this.querySelector('[data-gallery-prev]').addEventListener('click',()=>this.move(-1),options);
      this.querySelector('[data-gallery-next]').addEventListener('click',()=>this.move(1),options);
      this.dialog.addEventListener('keydown',event=>{
        if (event.key==='ArrowLeft' || event.key==='ArrowRight') {event.preventDefault();this.move(event.key==='ArrowLeft'?-1:1);}
      },options);
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const rect=this.dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)this.dialog.close();}},options);
      this.dialog.addEventListener('close',()=>{document.documentElement.classList.remove('pb-gallery-modal-open');this.opener?.focus({preventScroll:true});},options);
      document.addEventListener('shopify:block:select',event=>{
        const item=this.items.find(item=>item.dataset.blockId===event.detail?.blockId);
        if(!item)return;
        this.category='all';this.shown=Math.max(this.limit,this.items.indexOf(item)+1);this.update();
      },options);
      this.update();
    }
    update() {
      this.matches=this.items.filter(item=>this.category==='all'||item.dataset.category===this.category);
      const visible=new Set(this.matches.slice(0,this.shown));
      this.items.forEach(item=>{item.hidden=!visible.has(item);});
      this.filters.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===this.category)));
      this.querySelector('[data-gallery-count]').textContent=`${Math.min(this.shown,this.matches.length)} of ${this.matches.length} photos`;
      this.querySelector('[data-gallery-more]').hidden=this.shown>=this.matches.length;
    }
    move(step) {this.current=(this.current+step+this.matches.length)%this.matches.length;this.showPhoto();}
    showPhoto() {
      const item=this.matches[this.current]; if(!item)return;
      const image=this.querySelector('[data-viewer-image]'); image.src=item.querySelector('[data-gallery-open]').href;image.alt=item.querySelector('img').alt;
      this.querySelector('[data-viewer-title]').textContent=item.querySelector('[data-photo-title]').textContent;
      this.querySelector('[data-viewer-caption]').textContent=item.querySelector('[data-photo-caption]')?.textContent||'';
      this.querySelector('[data-viewer-count]').textContent=`${this.current+1} / ${this.matches.length}`;
      this.querySelector('[data-gallery-prev]').disabled=this.matches.length<2;
      this.querySelector('[data-gallery-next]').disabled=this.matches.length<2;
    }
    disconnectedCallback() {if(this.dialog?.open)this.dialog.close();this.controller?.abort();this.controller=null;}
  }
  customElements.define('pb-work-gallery',WorkGallery);
})();
